import { render, staticRenderFns } from "./CfoProfitLossSankey.vue?vue&type=template&id=1ea4da6a&scoped=true"
import script from "./CfoProfitLossSankey.vue?vue&type=script&lang=js"
export * from "./CfoProfitLossSankey.vue?vue&type=script&lang=js"
import style0 from "./CfoProfitLossSankey.vue?vue&type=style&index=0&id=1ea4da6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea4da6a",
  null
  
)

export default component.exports